<template>
  <div class="" :class="{read: email.seen, unread: !email.seen}">
    <div class="flex flex-column pt2 pb2 border-top muted-border mouse-cursor" style="cursor: pointer!important;" @click="showItemDetails(email)">
      <div class="col-12 flex justify-between items-start gibson">
        <div class="flex-none" style="width:40px;height:40px;background:rgba(0, 54, 69, 1.0);border-radius:50%;">
        </div>
        <div class="flex-auto px2">
          <p class="darkblue line-height-3 m0" style="font-size:1rem;">{{email.firstname}} {{email.lastname}}</p>
          <p class="mediumgrey line-height-3 m0" style="font-size:.875rem;">{{email.title}}</p>
        </div>
        <div class="flex-none">
          <p class="h6 muted gibson line-height-3 regular">
            {{moment(email.createtime).locale('da').format('Do MMMM') }}
          </p>
          <span class="mt2 col-12 mintgreen" v-if="email.file.length !== 0">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 -1.5 24 24" width="18" height="18" preserveAspectRatio="xMinYMin" class="jam jam-attachment right"><path d='M18.433 5.359a.933.933 0 0 1 1.357 0c.375.39.375 1.022 0 1.412L8.26 18.78a4.663 4.663 0 0 1-6.783 0c-1.873-1.95-1.873-5.113 0-7.064L11.65 1.12a2.798 2.798 0 0 1 4.07 0c1.124 1.17 1.124 3.068 0 4.239L6.902 14.54a.933.933 0 0 1-1.356 0 1.028 1.028 0 0 1 0-1.412l8.818-9.183a1.028 1.028 0 0 0 0-1.413.933.933 0 0 0-1.357 0L2.832 13.13c-1.123 1.17-1.123 3.068 0 4.238a2.798 2.798 0 0 0 4.07 0L18.433 5.359z'/></svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'messagebox',
  props: [
    'email',
    'starMessage',
    'bulkSelect'
  ],
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  methods: {
    showItemDetails (email) {
      email.SEEN = true
      this.$emit('showItemDetails', email)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Message.vue?1a737c34